module.exports = __webpack_public_path__ + "static/media/26.0fc84f19.jpg";